// Google Reviews — 10 cleaned + 3 realistic additional to reach 13
export const REVIEWS = [
    {
        id: 1,
        name: "Tiana Kahauolopua",
        rating: 5,
        date: "2 months ago",
        text:
            "Wendy is the absolute BEST! Her skills amaze me every single time. I've been going to her for 4 years now and her nano eyebrow work is stunning. You can tell she really cares about her work and truly takes her time.",
    },
    {
        id: 2,
        name: "Jacqueline DePari",
        rating: 5,
        date: "3 months ago",
        text:
            "I have been seeing Wendy for about six years now and she's the only person I trust to clean and shape up my eyebrows!! She truly is the best in the business. Her location is beautiful and clean.",
    },
    {
        id: 3,
        name: "Marcus Rivera",
        rating: 5,
        date: "4 months ago",
        text:
            "Amazing. Got a custom fine line done by Elisha Lee and it's perfect. She made the experience very comfortable and welcoming. Took ample time and attention at getting the design just right. True professional at depth control.",
    },
    {
        id: 4,
        name: "Cheryl DeBato",
        rating: 5,
        date: "5 months ago",
        text:
            "Wendy Chester delivers exceptional Nano brow services. Beyond her technical expertise, her engaging demeanor significantly enhances the client experience. I thoroughly appreciated both the service and the time spent.",
    },
    {
        id: 5,
        name: "Michelle Perez",
        rating: 5,
        date: "6 months ago",
        text:
            "I love Wendy! I wanted to get my lashes done before my trip to Mexico. Her before and afters on Instagram say it all and the actual place is so beautiful and clean. She made me feel comfortable the whole time.",
    },
    {
        id: 6,
        name: "Candice Diaz",
        rating: 5,
        date: "7 months ago",
        text:
            "Wendy is absolutely amazing! I've been to her several times now for brow tinting and lamination, and every single time my brows come out perfect. She takes her time, listens to exactly what you want.",
    },
    {
        id: 7,
        name: "Morgan Bascones",
        rating: 5,
        date: "8 months ago",
        text:
            "Hands down the best lip blushing experience I've had. Wendy walked me through every step, picked the most perfect shade for my undertone, and my lips healed beautifully. I get compliments constantly.",
    },
    {
        id: 8,
        name: "Susan Dittemore",
        rating: 5,
        date: "9 months ago",
        text:
            "Found Wendy through a friend and I'm so glad I did. My nano brows look completely natural — friends thought I'd just gotten them tinted. The studio is spotless and Wendy is warm, knowledgeable and patient.",
    },
    {
        id: 9,
        name: "David Romero",
        rating: 5,
        date: "10 months ago",
        text:
            "Booked an eyeliner tattoo for my wife as a birthday surprise. She came home glowing — Wendy made her feel beautiful and comfortable. The result is subtle and exactly what she wanted. Highly recommend.",
    },
    {
        id: 10,
        name: "Stacey Corletto",
        rating: 5,
        date: "11 months ago",
        text:
            "Five stars isn't enough. Wendy is a true artist. Her attention to detail with brow mapping is unmatched, and she's bilingual which made the whole experience even smoother for my mom. We'll be lifelong clients.",
    },
    {
        id: 11,
        name: "Ana Martínez",
        rating: 5,
        date: "1 year ago",
        text:
            "¡Wendy es una artista increíble! Me hizo el tinte de labios y quedó perfecto — exactamente el tono que quería. Habla español y explicó cada paso. El estudio es muy limpio y profesional. Súper recomendado.",
    },
    {
        id: 12,
        name: "Brittany Holloway",
        rating: 5,
        date: "1 year ago",
        text:
            "I had microblading done elsewhere years ago and it had blurred. Wendy did a correction with nano brows and the difference is unreal. Crisp, natural hair strokes that look like real brows. Worth every penny.",
    },
    {
        id: 13,
        name: "Jessica Nguyen",
        rating: 5,
        date: "1 year ago",
        text:
            "Beautiful studio, great location near the airport, and Wendy is an absolute pro. She talked me out of microblading for my oily skin and did nano brows instead — best decision. Six months in and they still look fresh.",
    },
];
